<script setup lang="ts">
import type { ListPaymentOptionsCreditPackage, ListPaymentOptionsSubscriptionDto } from '@swipe4work/models-orval'
import SubscriptionPageContent from './components/SubscriptionPageContent.vue'

definePage({
  path: '/upgrade/pakket',
  meta: {
    permissionResource: 'Lead',
    shell: {
      showLeadPromotion: false,
    },
  },
})

const upgradeStore = useUpgradeStore()

await upgradeStore.fill()
upgradeStore.fetchPaymentOptions()
const { creditPackage, creditPackages, jobSlotOptions, subscription, subscriptions } = storeToRefs(upgradeStore)

function prevPage() {
  upgradeStore.goToPage(0)
}

function selectCreditPackage(cp: ListPaymentOptionsCreditPackage) {
  creditPackage.value = cp
  subscription.value = undefined
  upgradeStore.goToPage(2)
}

function selectSubscription(sub: ListPaymentOptionsSubscriptionDto) {
  subscription.value = sub
  creditPackage.value = undefined
  upgradeStore.goToPage(2)
}
</script>

<template>
  <SubscriptionPageContent
    :credit-packages="creditPackages"
    :job-slot-options="jobSlotOptions"
    :subscriptions="subscriptions"
    @select-credit-package="selectCreditPackage"
    @select-subscription="selectSubscription"
    @prev-page="prevPage"
  />
</template>
